import React, { Component } from 'react'
import { Scrollbars } from 'react-custom-scrollbars'
import { noMoreLonelyWords } from './utilities/utilities.js';

class Cronology extends Component {
  constructor(props) {
    super(props)
  }

  componentDidUpdate() {
    noMoreLonelyWords("p", 2)
  }


  render() {
    return (
      <div className="cronologia wrapper-portfolio-pages">
        <h3>Trabalhos realizados a partir de 1993</h3>
        <Scrollbars className="scroll">
          <table>

            {
              this.props.data && this.props.data.map(
                (i, index) => {
                  return (
                    <tr key={index}>
                      <th className="column1"><p>• {i.year}</p></th>
                      <th className="column2"><p>{i.description}</p></th>
                    </tr>
                  )
                }
              )
            }

          </table>
        </Scrollbars>
        <div className="scroll-message">
          + Deslize o scroll para ver mais
      </div>
      </div>
    )
  }
}

export default Cronology;
















// WEBPACK FOOTER //
// ./src/Cronology.js